module.exports = __webpack_public_path__ + "img/personal_disc.cbbe2d83.svg";